export default __webpack_public_path__ + "static/media/recent_activity_2.a30a7973.jpg";